import idx from 'idx';
import request from 'axios';
import { createAction } from 'redux-actions';
import { getProject } from 'project/ducks/project';
import { getProjectEntries } from 'project/ducks/entries';
import { FETCH_SUCCESS } from 'project/ducks/common';
import * as commonImports from 'project/ducks/common';

export const SHOW_ENTRY = 'crowdspring/single-entry/show';

export const FETCH_SINGLE = 'crowdspring/single-entry/FETCH';
export const FETCH_SINGLE_REQUEST = 'crowdspring/single-entry/FETCH_REQUEST';
export const FETCH_SINGLE_SUCCESS = 'crowdspring/single-entry/FETCH_SUCCESS';
export const FETCH_SINGLE_ERROR = 'crowdspring/single-entry/FETCH_ERROR';

export const UPDATE_REVISION = 'crowdspring/single-entry/update-revision';

export const updateRevision = createAction(UPDATE_REVISION);

export const INITIAL_STATE = {
  isLoading: true,
  entriesById: {},
  entryIds: [],
  closeUrl: null,
  currentRevisionId: null,
};

export default function singleEntryReducer(state = INITIAL_STATE, action) {
  let newEntriesById;

  switch (action.type) {
    case SHOW_ENTRY: {
      return {
        ...state,
        currentRevisionId: null,
        entriesById: {},
        entryIds: action.payload.entryIds,
        closeUrl: action.payload.closeUrl,
      };
    }
    case FETCH_SUCCESS: {
      return {
        ...state,
        currentRevisionId: null,
        entryIds: idx(action.payload, _ => _.entry_ids) || []
      };
    }
    case FETCH_SINGLE_REQUEST: {
      return {
        ...state,
        currentRevisionId: null,
        isLoading: true,
      };
    }
    case FETCH_SINGLE_SUCCESS: {
      newEntriesById = { ...state.entriesById };
      newEntriesById[action.payload.id] = action.payload;
      return {
        ...state,
        isLoading: false,
        currentRevisionId: action.currentRevisionId || null,
        entriesById: newEntriesById,
      };
    }
    case UPDATE_REVISION: {
      return {
        ...state,
        currentRevisionId: action.payload,
      };
    }
    case commonImports.SCORE_REVISION_SUCCESS:
      newEntriesById = { ...state.entriesById };

      Object.keys(newEntriesById).forEach(entryId => {
        const { revisions } = newEntriesById[entryId];
        const revisionIdx = revisions.findIndex(rev => rev.id === action.payload.id);
        if (revisionIdx !== -1) {
          revisions[revisionIdx] = {
            ...revisions[revisionIdx],
            score: action.payload.score
          };
        }
      });

      return {
        ...state,
        entriesById: newEntriesById,
      };
    default:
      return state;
  }
}

export const showProjectEntry = closeUrl => (dispatch, getState) => {
  const state = getState();
  const project = getProject(state);
  const data = {
    entriesById: getProjectEntries(state),
    entryIds: project.entry_ids || [],
    closeUrl,
  };

  return dispatch({
    type: SHOW_ENTRY,
    payload: data,
  });
};

export const fetchSingleEntry = (projectId, id, currentRevisionId) => dispatch => (
  dispatch({
    type: FETCH_SINGLE,
    promise: request.get(`/api/v1/projects/${projectId}/entries/${id}/`),
    currentRevisionId
  })
);



// WEBPACK FOOTER //
// ./single_entry/ducks.js